export class Config { 

    data = {
        BASE_API: 'https://app.dineroagil.mx',
        BASE_UPLOADS_PATH: 'https://app.dineroagil.mx/Uploads',
        DISABLE_API: false
    };

    get(key) {
        return this.data[key];
    }

    set(key, value) {
        this.data[key] = value;
    }
} 


// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/local/config.ts